import { render, staticRenderFns } from "./EditTab.vue?vue&type=template&id=53f788b0"
import script from "./EditTab.vue?vue&type=script&lang=ts"
export * from "./EditTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53f788b0')) {
      api.createRecord('53f788b0', component.options)
    } else {
      api.reload('53f788b0', component.options)
    }
    module.hot.accept("./EditTab.vue?vue&type=template&id=53f788b0", function () {
      api.rerender('53f788b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/EditTab.vue"
export default component.exports